import { useState, useEffect, memo } from "react";
import axios from "axios";
import { HiUserAdd } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { motion } from "framer-motion";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

// پس‌ زمینه متحرک
const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
    cols = 11,
    arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = memo(() => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {staticBackgroundIcons.map((item, i) => (
      <motion.div
        key={i}
        className="absolute text-white/50"
        style={{
          top: `${item.top}%`,
          left: `${item.left}%`,
          opacity: item.opacity,
        }}
        initial={{ scale: 0.5 }}
        animate={{
          x: [0, item.xOffset, 0],
          y: [0, item.yOffset, 0],
          scale: [0.5, 1, 0.5],
        }}
        transition={{
          duration: item.duration,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <item.Icon size={item.size} />
      </motion.div>
    ))}
  </div>
));

const Editteacher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const teacherId = location.state?.teacherId;
  const API_BASE = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [National_Code, setNational_Code] = useState("");
  const [teacherDes, setTeacherDes] = useState("");

  const [uploadimage, setUploadimage] = useState("");
  const [showuploadicon, setShowuploadicon] = useState(true);
  const [apiimage, setApiimage] = useState("");
  const [imageid, setImageid] = useState("");

  // دریافت اطلاعات استاد
  const getteacher = async () => {
    if (!teacherId) return navigate("/Mainpage/TeachersInf");

    try {
      const res = await axios.get(
        `${API_BASE}/api/teacher/Get-Single-Teacher-By-Id/${teacherId}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );

      const data = res.data.data.teacherinf;
      setFirstName(data.firstName || "");
      setLastName(data.lastName || "");
      setEmail(data.email || "");
      setMobile(data.mobile || "");
      setNational_Code(data.National_Code || "");
      setTeacherDes(data.teacherDes || "");

      if (data.profile?.fileName) {
        setApiimage(`${API_BASE}/${data.profile.fileName}`);
        setShowuploadicon(false);
      }

      setLoading(false);
    } catch (err) {
      toast.error("خطا در دریافت اطلاعات");
      setLoading(false);
    }
  };

  useEffect(() => {
    getteacher();
  }, [teacherId]);

  // آپلود تصویر
  const handleuploadimage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setShowuploadicon(false);
    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(`${API_BASE}/api/files/admin/upload-file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        toast.success("تصویر با موفقیت آپلود شد");
        setImageid(res.data.data.fileId);
        setUploadimage(URL.createObjectURL(file));
        setApiimage("");
      })
      .catch(() => {
        toast.error("خطا در آپلود تصویر");
        setShowuploadicon(true);
      });
  };

  // ویرایش استاد
  const handleeditteacher = async () => {
    try {
      await axios.post(
        `${API_BASE}/api/teacher/Edit-Teacher/${teacherId}`,
        {
          firstName,
          lastName,
          email,
          mobile,
          National_Code,
          imageid: imageid || undefined,
          teacherDes,
        },
        { headers: { Authorization: localStorage.getItem("token") } }
      );
      toast.success("استاد با موفقیت ویرایش شد");
      navigate("/Mainpage/TeachersInf");
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در ویرایش");
    }
  };

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center py-12 px-4">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-5 w-full max-w-2xl mx-auto border border-white/30"
      >
        {/* هدر */}
        <div className="flex items-center justify-between mb-5">
          <img
            src={backarrow}
            alt="back"
            className="w-8 h-8 cursor-pointer hover:scale-110 transition"
            onClick={() => navigate(-1)}
          />
          <h2 className="text-xl font-medium text-gray-800">ویرایش استاد</h2>
          <div className="w-8" />
        </div>

        {/* تصویر پروفایل */}
        <div className="flex justify-center my-5">
          <div
            onClick={() => document.getElementById("openimage").click()}
            className="relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden cursor-pointer shadow-lg hover:scale-105 transition"
          >
            <input
              id="openimage"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleuploadimage}
            />
            {showuploadicon ? (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <HiUserAdd size={60} className="text-gray-600" />
              </div>
            ) : (
              <img
                src={uploadimage || apiimage}
                alt="teacher"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>

        {loading ? (
          <div className="text-center py-10 text-gray-600 font-medium">
            در حال دریافت اطلاعات...
          </div>
        ) : (
          <div className="space-y-4 text-sm">
            {/* نام و نام خانوادگی */}
            <div className="grid grid-cols-2 gap-3">
              <Input
                value={firstName}
                setValue={setFirstName}
                placeholder="نام"
              />
              <Input
                value={lastName}
                setValue={setLastName}
                placeholder="نام خانوادگی"
              />
            </div>

            {/* ایمیل و موبایل */}
            <div className="grid grid-cols-2 gap-3">
              <Input value={email} setValue={setEmail} placeholder="ایمیل" />
              <Input
                value={mobile}
                setValue={setMobile}
                placeholder="شماره موبایل"
                onlyNumbers
                maxLength={11}
              />
            </div>

            {/* کد ملی */}
            <Input
              value={National_Code}
              setValue={setNational_Code}
              placeholder="کد ملی"
              onlyNumbers
              maxLength={10}
            />

            {/* توضیحات */}
            <textarea
              value={teacherDes}
              onChange={(e) => setTeacherDes(e.target.value)}
              placeholder="توضیحات استاد..."
              rows={5}
              className="w-full p-4 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium resize-none bg-white/70"
            />

            {/* دکمه ذخیره */}
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleeditteacher}
              className="w-full py-4 bg-gray-800 hover:bg-gray-900 text-white font-bold rounded-lg shadow-xl transition mt-6"
            >
              ذخیره تغییرات
            </motion.button>
          </div>
        )}
      </motion.div>
    </div>
  );
};

const Input = ({
  value,
  setValue,
  placeholder,
  maxLength,
  onlyNumbers,
  className = "",
}) => (
  <input
    type="text"
    value={value}
    onChange={(e) => setValue(e.target.value)}
    placeholder={placeholder}
    maxLength={maxLength}
    onKeyDown={(e) =>
      onlyNumbers &&
      !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key) &&
      e.preventDefault()
    }
    className={`w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium text-sm bg-white/70 transition ${className}`}
  />
);

export default Editteacher;
